import { FaWhatsapp } from "react-icons/fa"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui-lab/tooltip"
import { portfolioData } from "@/data/portfolioData"

const WHATSAPP_NUMBER = portfolioData.personal_info.phone.replace(/\D/g, "")
const WHATSAPP_MESSAGE = "Hi Amit, I came across your portfolio and would like to connect."
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`

export const WhatsAppButton = () => (
  <Tooltip>
    <TooltipTrigger asChild>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110"
      >
        <FaWhatsapp size={26} aria-hidden="true" />
      </a>
    </TooltipTrigger>
    <TooltipContent side="left">Chat on WhatsApp</TooltipContent>
  </Tooltip>
)
